import React from 'react';
import ModulesCatalog from './ModulesCatalog';
import ModuleDetailsPanel from './ModuleDetailsPanel';
import FlowColumn from '../modules/FlowColumn';

/**
 * The 3-column body of the Create Interview modal.
 * Desktop: 3 columns side-by-side. Mobile: one column visible at a time
 * controlled by `mobileTab`.
 */
export default function ModalBody({
  catalog,
  flow,
  setFlow,
  selected,
  selectedId,
  mobileTab,
  onAddModule,
  onSelectModule,
  onRemoveModule,
  onUpdateModule,
  openingPhrase,
  setOpeningPhrase,
}) {
  return (
    <div className="flex-1 lg:grid lg:grid-cols-[260px_300px_1fr] flex flex-col overflow-hidden">
      <ModulesCatalog
        catalog={catalog}
        flow={flow}
        onAdd={onAddModule}
        visible={mobileTab === 'modules'}
      />
      <FlowColumn
        visible={mobileTab === 'flow'}
        flow={flow}
        selectedId={selectedId}
        onSelect={onSelectModule}
        onRemove={onRemoveModule}
        onReorder={setFlow}
      />
      <ModuleDetailsPanel
        selected={selected}
        openingPhrase={openingPhrase}
        setOpeningPhrase={setOpeningPhrase}
        onUpdate={onUpdateModule}
        visible={mobileTab === 'details'}
      />
    </div>
  );
}
